var render, staticRenderFns
import script from "./inspectionList.vue?vue&type=script&lang=js&"
export * from "./inspectionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bd846c",
  null
  
)

export default component.exports